<section class="container py-2">
  <form class="row">
    <div class="col-12 col-md ">
      <input type="search" placeholder="جستجو" name="keyword" [(ngModel)]="keyword" (input)="load()">
    </div>
    <div class="col-2">
      <input type="button" value="کاریابی جدید" (click)="newuser()">
    </div>
  </form>
  <div class="col-12">
    <app-pagination [total]="total" [limit]="limit" (page)="load($event)"></app-pagination>
  </div>
  <hr>
  <section class="relative">
    <ngx-spinner name="search" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
    <div class="row flex-row kp-card" *ngFor="let user of users">
      <ngx-spinner [name]="'action-'+user.Id" [fullScreen]="false" type="timer" size="small"></ngx-spinner>
      <div class="col-12">
        <!-- <form #userForm="ngForm"> -->
        <header class="fs-sm f-gray row mb-1">
          <div class="col-12 col-sm-8 ">
            <span class="f-blue">ثبت نام: {{user.CreateDate|pdate}}</span>
            <span class="f-green"> | بروزرسانی: {{(user.Seeker?.LastUpdate || user.LastUpdate)|pdate}}</span>

          </div>
          <div class="col-12 col-sm-4 text-left">
            <ng-container *ngIf="user.Seeker?.Code">کد رزومه: {{user.Seeker.Code}}</ng-container>
          </div>
        </header>
        <input *ngIf="!user.Username" type="text" name="name" class="col-3" [(ngModel)]="user.Name">
        <h3 *ngIf="user.Username">{{user.Name}} - <span class="fs-sm">{{user.Username}} </span></h3>
        <div class="row">
          <div class="col-12 f-gray border p-1" *ngIf="user.Agent">
            <h6>تنظیمات کاریابی</h6>
            <div class="row">
              <label class="col-2">
                نام کاریابی
                <input type="text" name="types" [(ngModel)]="user.Agent.Company">
              </label>
              <label class="col-2">
                درصد پورسانت
                <input type="number" inputmode="numeric" name="percentage" placeholder="درصد پورسانت" [(ngModel)]="user.Agent.Percentage">
              </label>
              <div class="col row">
                <label class="col-6">
                  <input type="checkbox" name="types" [(ngModel)]="user.Agent.Disabled">
                  غیرفعال شود
                </label>
                <label class="col-6">
                  <input type="checkbox" name="types" [(ngModel)]="user.Agent.IsTrusted">
                  انتشار آگهی‌ها بدون نیاز به تایید اپراتور
                </label>
                <label class="col-6">
                  <input type="checkbox" name="types" [(ngModel)]="user.Agent.IsLegal">
                  نوع کاریابی حقوقی
                </label>
              </div>
            </div>
            <div class="row">
              <label class="col-2">
                شهر، استان
                <app-location name="location" [(ngModel)]="user.Agent"></app-location>
              </label>
              <label class="col-2">
                محله
                <input type="text" name="types" [(ngModel)]="user.Agent.District" />
              </label>
              <label class="col">
                آدرس
                <input type="text" name="address" [(ngModel)]="user.Agent.Address" />
              </label>
              <label class="col">
                تلفن‌ها
                <ng-select name="phones" [multiple]="true" [(ngModel)]="user.Agent.Phones" addTagText="افزودن"
                  [selectOnTab]="true" [inputAttrs]="{type:'phone'}" [addTag]="addTag">
                </ng-select>
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="btn-group">
            <a class="btn btn-yellow" *ngIf="user.Seeker" [routerLink]="['/seeker','profile',user.Id]">رزومه</a>
            <button type="submit" class="btn btn-red" (click)="save(user)">ذخیره</button>
          </div>
        </div>
        <!-- </form> -->
      </div>
    </div>
  </section>
</section>